export const sagardiConfigurations = {
  sagardi_configurations: "Configuraciones de Sagardi",
  sagardi_integration_unsupported: `La integración de Sagardi no es compatible todavía`,
  sagardi_postprocessed_json_required:
    "Se requiere json postprocesado de Sagardi",
  sagardi_docCls_actCls_required:
    "Se requieren la clase de documento y la clase de cuenta de Sagardi",
};
